import "./LoginStyle.css";
import fEMR_logo from "../resources/fEMR_logo.png";
import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { RoleContext } from "../App";
import { MdOutlineKeyboardReturn } from "react-icons/md";
import axios from "axios";

const Login = () => {
  const { role } = useContext(RoleContext);
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState({});
  const [, setUserInfo] = useState({});
  const PORT =
    "http://SkeleChaingang-env.eba-i65amzvv.us-west-2.elasticbeanstalk.com";
  // const PORT = 'http://femr-central-api.us-west-2.elasticbeanstalk.com';
  function handleChange(event) {
    const { value } = event.target;
    setUser({
      ...user,
      [event.target.name]: value,
    });
  }

  function validate() {
    let bool = true;
    let errors = {};
    if (user.email.length === 0) {
      errors.email = "Please enter your email.";
      bool = false;
    }
    if (user.password.length === 0) {
      errors.password = "Please enter your password.";
      bool = false;
    }
    setError(errors);
    return bool;
  }

  const submitForm = (e) => {
    e.preventDefault();
    const bool = validate();
    if (bool) {
      const fetchUser = async () => {
        try {
          const response = await axios.get(`${PORT}/user/${user.email}/`);
          return response.data;
        } catch (error) {
          return false;
        }
      };

      fetchUser().then((result) => {
        if (result) {
          const pw = result.password;
          if (role === result.roles[0].name) {
            if (pw === user.password) {
              setUserInfo(result);
              console.log("result = ", result);
              localStorage.setItem("userInfo", JSON.stringify(result));

              setTimeout(() => {
                window.location.reload();
                setTimeout(() => {
                  window.location.href = "/";
                }, 0);
              }, 5);
            } else {
              setError((prevError) => ({
                ...prevError,
                login: "Error! Incorrect Password!",
              }));
              setUser((prevUser) => ({
                ...prevUser,
                password: "",
              }));
            }
          } else {
            setError((prevError) => ({
              ...prevError,
              login: `Error! Incorrect Role! \n Please go back to the previous page.`,
            }));
          }
        } else {
          setError((prevError) => ({
            ...prevError,
            login: "Error! User not found!",
          }));
          setUser((prevUser) => ({
            ...prevUser,
            email: "",
            password: "",
          }));
        }
      });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      submitForm(e);
    }
  };

  return (
    <div className="container">
      <div className="header">
        <img className="logo" src={fEMR_logo} alt="" />
        {role && <p className="user">{role}</p>}
      </div>
      <form className="box" onSubmit={submitForm}>
        <p className={error.login ? "redBox" : "errorMessage"}>{error.login}</p>
        <p className="text">Username</p>
        <input
          className={error.email ? "input red-border" : "input"}
          placeholder="email"
          name="email"
          value={user.email}
          onChange={handleChange}
        />
        <p className="errorMessage">{error.email}</p>
        <p className="text">Password</p>
        <input
          className={error.password ? "input red-border" : "input"}
          type="password"
          name="password"
          placeholder="password"
          value={user.password}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <p className="errorMessage">{error.password}</p>
        <button className="btn">Log In</button>
        <p className="link">
          <Link to="/login/confirm-email"> Forgot Password </Link>
          <div className="returnBox">
            <MdOutlineKeyboardReturn size="20px" color="#a1060f" />
            <Link to="/welcome"> Go Back </Link>
          </div>
        </p>
      </form>
    </div>
  );
};

export default Login;
